// src/context/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr'); // 'fr' par défaut

  useEffect(() => {
    // Vérifiez si l'utilisateur a déjà une préférence
    const storedLanguage = localStorage.getItem('language');
    if (storedLanguage) {
      setLanguage(storedLanguage);
    } else {
      // Sinon, vérifiez la langue du navigateur
      const browserLanguage = navigator.language.split('-')[0];
      if (browserLanguage === 'en' || browserLanguage === 'fr') {
        setLanguage(browserLanguage);
        localStorage.setItem('language', browserLanguage);
      }
    }
  }, []);

  const toggleLanguage = () => {
    const newLanguage = language === 'fr' ? 'en' : 'fr';
    setLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

export default LanguageContext;